import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { IUserProfileEditItem, UserProfileEditItem } from "./userProfileEditItem";
import { Base } from "ui/Scripts/source/framework/base";

export interface IUserProfileEdit {
    minPasswordLength: number;
    qrCodeLoginUrlTemplate: string;
    allowedCompanies: ICompanyMenuItem[];
    msAuthenticationEnabled: boolean;
    msAuthenticationClientId: string;
    msAuthenticationRedirectUri: string;
    userProfile: IUserProfileEditItem;
}

export class UserProfileEdit implements IUserProfileEdit {
    minPasswordLength: number;
    qrCodeLoginUrlTemplate: string;
    allowedCompanies: CompanyMenuItem[];
    msAuthenticationEnabled: boolean;
    msAuthenticationClientId: string;
    msAuthenticationRedirectUri: string;
    userProfile: UserProfileEditItem;

    constructor();
    constructor(obj: IUserProfileEdit);
    constructor(obj?: any) {
        this.minPasswordLength = obj && obj.minPasswordLength || 0;
        this.qrCodeLoginUrlTemplate = obj && obj.qrCodeLoginUrlTemplate || "";
        this.allowedCompanies = Base.getTypedArray(obj?.allowedCompanies, CompanyMenuItem);
        this.msAuthenticationEnabled = obj && obj.msAuthenticationEnabled || false;
        this.msAuthenticationClientId = obj && obj.msAuthenticationClientId || "";
        this.msAuthenticationRedirectUri = obj && obj.msAuthenticationRedirectUri || "";
        this.userProfile = new UserProfileEditItem(obj ? obj.userProfile : null);
    }
}